import { createUseStyles } from 'react-jss';
import { Spacings } from '../../../../foundation/spacings/spacings/index.js';
import { BreakPointsMedia } from '../../../../foundation/responsive/responsive/index.js';

const useStyles = createUseStyles({
    root: {
        width: '100%',
        margin: '0 auto',
        [BreakPointsMedia.XXL]: {
            maxWidth: 1600,
            padding: `0 ${Spacings.s24}`,
        },
        [BreakPointsMedia.XL]: {
            maxWidth: 1366,
            padding: `0 ${Spacings.s24}`,
        },
        [BreakPointsMedia.LG]: {
            maxWidth: 1280,
            padding: `0 ${Spacings.s24}`,
        },
        [BreakPointsMedia.MD]: {
            maxWidth: 1024,
            padding: `0 ${Spacings.s24}`,
        },
        [BreakPointsMedia.SM]: {
            maxWidth: 768,
            padding: `0 ${Spacings.s12}`,
        },
        [BreakPointsMedia.XS]: {
            maxWidth: 480,
            padding: `0 ${Spacings.s12}`,
        },
        [BreakPointsMedia.XXS]: {
            maxWidth: '100%',
            padding: `0 ${Spacings.s12}`,
        },
    },
}, {
    name: 'horizontal-container',
});

export { useStyles };
